import React, { useState } from 'react';
import { EmptyPage } from '../EmptyPage';
import { Link, useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import {ReactComponent as HouseIcon} from '../../assets/house.svg';
// import HouseIcon from '../../assets/house.svg';
import { Button } from '../../components/Button';
import { AddressContentPopup } from './AddressContentPopup';
import { WrapWindow } from '../../components/WrapWindow';
import CopyToClipboardButton from '../../components/CopyToClipboardButton';
import { EditFinishRoutePopup } from './EditFinishRoutePopup';
import { advertAPI } from '../../api';
import { getFinishedRoute } from '../../redux/advertSlice';


function getProgressData(finish) {
    const {isFullReport, progress} = finish;

    let successPorchCount = null;
    let successMailboxCount = null
    let spentMailboxCount = null

    if (isFullReport) {
        successPorchCount = progress.reduce((total, cur) => total + cur.donePorches.filter(pInfo => pInfo.photoUrls.length >= 2 && pInfo.videoUrl.name && !pInfo.rejectComment).length, 0)
        successMailboxCount = progress.reduce((total, cur) => total + Math.round(cur.mailboxCount*(cur.donePorches.filter(pInfo => pInfo.photoUrls.length >= 2 && pInfo.videoUrl.name && !pInfo.rejectComment).length/cur.porchCount)), 0)
        spentMailboxCount = progress.reduce((total, cur) => total + Math.round(cur.mailboxCount*(cur.donePorches.filter(pInfo => pInfo.photoUrls.length || pInfo.videoUrl.name).length/cur.porchCount)), 0)
    } else {
        successPorchCount = progress.reduce((total, cur) => total + cur.donePorchUrls.filter(p => !p.rejectComment).length, 0)
        successMailboxCount = progress.reduce((total, cur) => total + Math.round(cur.mailboxCount*(cur.donePorchUrls.filter(p => !p.rejectComment).length/cur.porchCount)), 0)
        spentMailboxCount = progress.reduce((total, cur) => total + Math.round(cur.mailboxCount*(cur.donePorchUrls.length/cur.porchCount)), 0)
    }
    return {successPorchCount, successMailboxCount, spentMailboxCount}
}

const RouteAddress = ({data, finishedRoute}) => {
    const {isFullReport, promoter:prom, city} = finishedRoute;
    const promoter = {...prom, isFullReport, city}
    
    //general
    const missedPorchCount = data.missedPorches.length; 
    let markedCount = null;
    let allChecked = null;
    let rejectedCount = null;
    let clearCount = null;

    //photo report
    if (!isFullReport) {
        allChecked = !data.donePorchUrls.some(p => !p.checked);
        markedCount = data.donePorchUrls.length + missedPorchCount;
        rejectedCount = data.donePorchUrls.filter(p => p.rejectComment).length;
        clearCount = markedCount - missedPorchCount - rejectedCount;
    }
    const isHouseDone = markedCount === data.porchCount;


    //full report
    const filledPorches = data.donePorches.filter(p => p.videoUrl.name || p.photoUrls.length).map(p => p.id);
    const fullfilledPorches = data.donePorches.filter(p => p.videoUrl.name && p.photoUrls.length >= 2).map(p => p.id);
    const processPorchCount = fullfilledPorches.length + missedPorchCount;
    const isPorchDone = processPorchCount === data.porchCount;

    const checkedPorches = data.donePorches.filter(p => p.checked).map(p => p.id);
    if (isFullReport) {
        markedCount = filledPorches.length;
        allChecked = checkedPorches.length === data.porchCount;
        rejectedCount = data.donePorches.filter(p => p.rejectComment).length;
        clearCount = data.donePorches.filter(p => p.videoUrl.name && p.photoUrls.length >= 2 && !p.rejectComment).length;
    }

    const [popup, setPopup] = useState(null);

    const setPopupHandler = (porchId) => {
        const obj = {houseId: data.houseId, porchId};
        setPopup(obj);
    }

    let popupContent = null;
    if (popup && isFullReport) {
        const selectedPorch = data.donePorches.find(p => p.id === popup.porchId);
        popupContent = selectedPorch.photoUrls.map(ph => ({fileName: ph.name, isPhoto: true, type: 'promHousePhoto'}));
        if (selectedPorch.videoUrl.name) {
            popupContent.push({fileName: selectedPorch.videoUrl.name, isPhoto: false, type: 'promHouseVideo'})
        }
    } else if (popup && !isFullReport) {
        popupContent = data.donePorchUrls.map(ph => ({fileName: ph.name, isPhoto: true, type: 'promHousePhoto'}));
    }

    return (
        <div className="route__address address-item dark-theme-bg1">
            {popup && <AddressContentPopup
                closeFn={() => setPopup(null)}
                content={popupContent}
                isCurrentRoute={true}
                routeId={'null'}
                promoter={promoter}
                address={data}
                porchId={popup.porchId}
                isFinishedRoute={true}
            />}
            <div className="address-item__header">
                <div className="address-item__icon"><HouseIcon width={36} height={36}/></div>
                <div className="address-item__main">
                    <h4>{data.name}</h4>
                    <div>
                        <p>Подъездов: <span>{data.porchCount}</span></p>
                        <p>Квартир: <span>{data.mailboxCount}</span></p>
                    </div>
                </div>
            </div>
            <div className="address-item__body">
                <div className="address-item__row">
                    <div className='address-item__progress'>
                        {isFullReport && <p>
                            {isPorchDone ? 'Отмечены' : processPorchCount ? 'В процессе' : 'Не отмечены'} {!!processPorchCount && `(${processPorchCount}/${data.porchCount})`}
                        </p>}
                        {!isFullReport && <p>
                            {isHouseDone ? 'Отмечены' : markedCount ? 'В процессе' : 'Не отмечены'} {!!markedCount && `(${markedCount}/${data.porchCount})`}
                        </p>}
                        {!!data.missedPorches.length && <p title={data.missedPorches.join(', ')} style={{color: missedPorchCount ? 'darkred' : 'inherit'}}>
                            Проблемных: {data.missedPorches.length || 'нет'}
                        </p>}
                        {!!rejectedCount && <p style={{color: 'red'}}>
                            Отклонено: {rejectedCount}
                        </p>}
                        {!isFullReport && !!clearCount && <p style={{color: 'green'}}>
                            Чистых: {clearCount} ({Math.round(data.mailboxCount*(data.donePorchUrls.filter(p => !p.rejectComment).length/data.porchCount))}ящ.)
                        </p>}
                        {isFullReport && !!clearCount && <p style={{color: 'green'}}>
                            Чистых: {clearCount} ({Math.round(data.mailboxCount*(data.donePorches.filter(p => !p.rejectComment && p.photoUrls.length >= 2 && p.videoUrl.name).length/data.porchCount))}ящ.)
                        </p>}
                    </div>
                    {!isFullReport && <div className='address-item__button'>
                        <Button disabled={!data.donePorchUrls.length} classNames={`${!markedCount?'':allChecked?'checked':''}`} text={allChecked ? 'Просмотрен':'Просмотр'} onClick={() => setPopupHandler(null)}/>
                    </div>}
                    {isFullReport && <div className='address-item__porch-buttons'>
                        {data.donePorches.map(p => 
                            <Button classNames={`${checkedPorches.some(p1 => p1 === p.id) ? 'checked':''} ${data.missedPorches.some(p1 => p1 === p.id) ? 'missed':''} ${p.rejectComment ? 'rejected':''}`}
                            key={p.id} disabled={!filledPorches.some(p1 => p1 === p.id) || data.missedPorches.some(p1 => p1 === p.id)}
                            text={String(p.id)} onClick={() => setPopupHandler(p.id)}/>
                        )}
                    </div>}
                </div>
            </div>
            <div className="route-item__footer">
                {!isFullReport && <div className='address-item__checked-info' style={{color: !markedCount ? 'inherit' : allChecked ? 'green' : 'inherit'}}>
                    {!markedCount ? 'Нет данных' : allChecked ? 'Проверен' : 'Не проверен'}
                </div>}
                {isFullReport && <div className='address-item__checked-info' style={{color: fullfilledPorches.length ? allChecked ? 'green' : checkedPorches.length ? 'yellow' : markedCount ? 'inherit' : 'inherit' : 'inherit'}}>
                    {fullfilledPorches.length ? allChecked ? 'Проверен' : checkedPorches.length ? 'Проверен частично' : markedCount ? 'Не проверен' : 'Нет данных' : 'Нет данных'}
                </div>}
            </div>
        </div>
    )
}

function generateRouteReportText(route) {
    const {
        addPorchCount:porchAmount,
        plusPayment:offsetPositive,
        plusPaymentOwn:offsetOwnPositive,
        minusPayment:offsetNegative,
        addPaymentComment:offsetComment
    } = route.additional;
    const {isNatural} = route.details;
    const doneSpreadCount = route.details.givenFlyersCount[0].doneSpreadCount;
    const {isFullReport, bet, flyers, progress} = route;
    let str = '';

    const {successMailboxCount} = getProgressData(route);
    const progressPercent = Math.round((successMailboxCount/route.mailboxCount)*100);

    for (let i = 0; i < progress.length; i++) {
        const h = progress[i];

        const rejectedPorches = isFullReport ?
        h.donePorches.filter((p) => !!p.rejectComment)
        : h.donePorchUrls.filter((p) => !!p.rejectComment);

        const doneCount = isFullReport ?
        h.donePorches.filter((p) => p.photoUrls.length >= 2 && !!p.videoUrl.name && !p.rejectComment).length
        : h.donePorchUrls.filter((p) => !p.rejectComment).length;

        const houseFlyersCount = Math.round(h.mailboxCount*(doneCount/h.porchCount));

        str += `\n${h.name} (${doneCount}/${h.porchCount})`
        if (houseFlyersCount) {
            str += ` ${houseFlyersCount}л. ${(houseFlyersCount*bet).toFixed(2)}руб.`
        }
        if (rejectedPorches.length) {
            str += rejectedPorches.map((p) => `\n\t• ${p.id}п отклонен: (${p.rejectComment})`)
        }
        str += '\n'
    }
    str += '🔻'.repeat(10)

    const result = isNatural ? Math.floor(+(successMailboxCount*bet + (+porchAmount*20*bet)).toFixed(2)) : Math.floor(+(bet*doneSpreadCount).toFixed(2));

    let resultStr = `Пром ${route.promoter.fullname}\nМаршрут #${route.route.id} (выполнен на ${progressPercent}%)
${flyers.map(f => f.name).join(', ')}
•Дата и кол-во ящиков:
${new Date(route.details.finishedAt).toLocaleDateString()} = ${isNatural ? successMailboxCount + porchAmount*20 : doneSpreadCount}
•Ставка: ${bet}
•Итог: ${result}`

    const add = offsetPositive + offsetOwnPositive - offsetNegative;
    if (offsetPositive || offsetOwnPositive || offsetNegative) {
        resultStr += `\nБонус: ${offsetPositive + offsetOwnPositive - offsetNegative}${offsetComment ?` (${offsetComment})`:''}`
    }
    resultStr += `\n•К оплате ${result + add}`

    return `${resultStr}\n${'🔻'.repeat(10)}${str}`
}

export const FinishedRoutePage = ({routes}) => {

    const { pathname } = useLocation();
    const finishId = pathname.split('/')[pathname.split('/').length - 1];

    const thisFinish = routes.find(r => r._id === finishId);
    const dispatch = useDispatch();
    const [editFinishPopup, setEditFinishPopup] = useState(false);
    const [requestSended, setRequestSended] = useState(false);


    if (!thisFinish) {
        if (!requestSended) {
            dispatch(getFinishedRoute({routeId: finishId}));
            setRequestSended(true);
            return <EmptyPage message='Ищем маршрут...' />;
        }
        return <EmptyPage message='Этот маршрут не существует' />
    }
    
    const {successMailboxCount, spentMailboxCount} = getProgressData(thisFinish);

    const progressPercent = Math.round((successMailboxCount/thisFinish.mailboxCount)*100);

    const {bet, additional, details} = thisFinish;
    const {givenFlyersCount, isNatural} = details;

    const {
        addPorchCount:porchAmount,
        plusPayment:offsetPositive,
        plusPaymentOwn:offsetOwnPositive,
        minusPayment:offsetNegative,
        addPaymentComment:offsetComment
    } = additional;
    const doneSpreadCount = givenFlyersCount[0].doneSpreadCount;

    function getRouteTotalPayment() {
        const additionFlyers = porchAmount ? ` + (${bet} руб x ${porchAmount}п. x 20л.)` : '';
        const sumPlusOwn = offsetOwnPositive ? `\n+ ${offsetOwnPositive} руб` : '';
        const sumPlus = offsetPositive ? `\n+ ${offsetPositive} руб` : '';
        const sumMinus = offsetNegative ? `\n- ${offsetNegative} руб` : '';
        if (!isNatural) {
            return `${bet} * ${doneSpreadCount}ящ${sumPlus}${sumPlusOwn}${sumMinus} = ${(bet*doneSpreadCount+offsetPositive+offsetOwnPositive+offsetNegative).toFixed(2)} руб`
        }
        const total = (bet*successMailboxCount + bet*(+porchAmount)*20+(+offsetPositive)-(+offsetNegative)).toFixed(2);
        return `${bet} руб x ${successMailboxCount}ящ${additionFlyers}${sumPlus}${sumPlusOwn}${sumMinus} = ${total} руб (всего листовок потрачено: ${spentMailboxCount + (+porchAmount || 0)*20})`
    }
    const {progress, isFullReport} = thisFinish;

    const ReportBody = () => {

        const AddressItem = ({name, mailboxCount, porchCount, donePorches, donePorchUrls}) => {
            const rejectedPorches = isFullReport ?
                donePorches.filter((p) => !!p.rejectComment)
                : donePorchUrls.filter((p) => !!p.rejectComment);

            const doneCount = isFullReport ?
                donePorches.filter((p) => p.photoUrls.length >= 2 && !!p.videoUrl.name && !p.rejectComment).length
                : donePorchUrls.filter((p) => !p.rejectComment).length;
    
            const houseFlyersCount = Math.round(mailboxCount*(doneCount/porchCount));
            return (
                <li className='route__report-item'>
                    <div>
                        <div>{name}</div>
                        <div>({doneCount}/{porchCount})</div>
                        {!!doneCount && <div>{houseFlyersCount}л</div>}
                        {!!doneCount && <div>{(houseFlyersCount*bet).toFixed(2)}руб</div>}
                    </div>
                    {!!rejectedPorches.length && <ul className='route__report-reject-info'>
                        {rejectedPorches.map((p, i) => <li key={`${p.id}_${i}`}>{p.id}п отклонен: ({p.rejectComment})</li>)}
                    </ul>}
                </li>
            )
        }

        let total = null;
        if (isNatural) {
            total = (bet*successMailboxCount + bet*(+porchAmount)*20+(+offsetPositive)+(+offsetOwnPositive)-(+offsetNegative)).toFixed(2);
        } else {
            total = (bet*doneSpreadCount + (+offsetPositive) + (+offsetOwnPositive) - (+offsetNegative)).toFixed(2);
        }
        return (
            <ul className='route__report-list'>
                {progress.map(h => <AddressItem key={h.houseId} mailboxCount={h.mailboxCount} porchCount={h.porchCount} name={h.name} donePorches={h.donePorches || []} donePorchUrls={h.donePorchUrls} />)}
                {(!!porchAmount || !!offsetPositive || !!offsetOwnPositive || !!offsetNegative) && <div className="route__report-additional-item">
                    <span>Дополнительно:</span>
                    {!!porchAmount && <p>{porchAmount}п. по 20 листовок = {+porchAmount*20}л. = {+porchAmount*20*bet} руб</p>}
                    {(!!offsetPositive || !!offsetOwnPositive || !!offsetNegative) && <p>{offsetPositive ? `+${offsetPositive}руб `:''}{offsetOwnPositive ?`+ ${offsetOwnPositive} руб `:''}{offsetNegative ?`- ${offsetNegative} руб `:''}= {+offsetPositive +(+offsetOwnPositive) - +offsetNegative}руб{offsetComment ? ` (${offsetComment})`:''}</p>}
                </div>}
                <div className="route__report-results-item">
                    <span>Итого:</span>
                    <p>{total} рублей за маршрут</p>
                </div>
            </ul>
        )
    }
    const ReportFooter = () => {
        const setTextCopyHandler = () => {
            return generateRouteReportText(thisFinish);
        }
        return (
            <div style={{textAlign:'center'}}>
                <CopyToClipboardButton className='button' setTextToCopy={setTextCopyHandler}/>
            </div>
        )
    }

    const sortedAddresses = [...progress].map(pr => ({...pr, orderIndex: isFullReport ? Number(!!pr.donePorches.find(dp => dp.photoUrls.length || dp.videoUrl.name)) : Number(!!pr.donePorchUrls.length)}))
    .sort((a,b) => b.orderIndex - a.orderIndex);

    return (
        <div className="finished-route">
            {editFinishPopup && <EditFinishRoutePopup data={thisFinish} closeFn={() => setEditFinishPopup(false)} />}
            <div className="container">
                <div className='route'>
                    <div className="route__header">
                        <h2>Маршрут #{thisFinish.route.id} | {thisFinish.promoter.fullname} | выполнен на {progressPercent}%
                            <Link className='button' to={`../map?routeId=${thisFinish.route.id}`}>Показать на карте</Link>
                        </h2>
                    </div>
                    <div className="route__body">
                        <WrapWindow minWidth={'490px'} maxWidth={'490px'} title={`Отчёт по маршруту #${thisFinish.route.id}`} subtitle={thisFinish.promoter.fullname} body={<ReportBody />} footer={<ReportFooter />} />
                        <div className="route__addresses-grid">
                            {sortedAddresses.map(addr => <RouteAddress finishedRoute={thisFinish} key={addr.houseId} data={addr} />)}
                        </div>
                    </div>
                    <div className="route__footer">
                        <div className="route__payment-hint">
                            Итого за маршрут: {getRouteTotalPayment()}
                        </div>
                        <div className="route__buttons">
                            <Button text="Редактировать" onClick={() => setEditFinishPopup(true)} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
